import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';

const heroBg =
  'https://images.unsplash.com/photo-1588676509970-63fe490c3712?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxmaXNoaW5nJTIwcG9uZCUyMG5hdHVyZXxlbnwwfHx8fDE3ODEzMjY5OTN8MA&ixlib=rb-4.1.0&q=85';

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-end"
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${heroBg})` }}
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-b from-pond/30 via-pond/10 to-pond/70"
      />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-20 md:pb-28 pt-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: 'easeOut' }}
          className="max-w-3xl"
        >
          <p className="overline text-offwhite/85 mb-6" data-testid="hero-overline">
            A peaceful retreat in Meycauayan, Bulacan
          </p>
          <h1
            className="editorial-display text-offwhite text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight"
            data-testid="hero-headline"
          >
            Kasama ang pamilya,
            <br />
            barkada, o sarili—
            <br />
            <em className="italic font-light text-sky">relax, fish, repeat.</em>
          </h1>
          <p
            className="mt-7 text-offwhite/90 text-lg md:text-xl max-w-xl leading-relaxed"
            data-testid="hero-subheadline"
          >
            Pond fishing, beginner lessons, BBQ tambayan, at ecological retreat — perfect day-trip mula Manila para sa pamilya, barkada, o sa sarili mong sandali ng pahinga.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Button
              as="a"
              href="#book"
              variant="primary"
              size="lg"
              data-testid="hero-book-btn"
              className="bg-offwhite text-pond hover:bg-sky hover:text-pond"
            >
              Book a Visit
            </Button>
            <Button
              as="a"
              href="#rates"
              variant="secondary"
              size="lg"
              data-testid="hero-rates-btn"
              className="border-offwhite/70 text-offwhite hover:bg-offwhite hover:text-pond"
            >
              View Rates
            </Button>
          </div>
        </motion.div>

        <motion.a
          href="#trust"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.85 }}
          transition={{ delay: 1.4, duration: 1 }}
          className="hidden md:flex absolute right-10 bottom-12 items-center gap-3 text-offwhite/90 hover:text-offwhite"
          data-testid="hero-scroll-cue"
        >
          <span className="overline rotate-90 origin-right -translate-x-6">Scroll</span>
          <ArrowDown className="w-4 h-4 animate-bounce" />
        </motion.a>
      </div>
    </section>
  );
}
